import { useLocalStorage } from '@vueuse/core'

enum Locales {
  CS = 'cs',
  EN = 'en',
  HR = 'hr',
  HU = 'hu',
  PL = 'pl',
  DE = 'de',
  IT = 'it',
  RO = 'ro',
  SK = 'sk',
  UK = 'uk',
  RU = 'ru',
  ES = 'es',
  BG = 'bg',
  PT = 'pt',
  FR = 'fr',
  NL = 'nl',
}

const defaultLocale = (): Locales => {
  const browserLanguage = navigator.language.split('-')[0]

  if (Object.values(Locales).includes(browserLanguage as Locales)) {
    return browserLanguage as Locales
  }

  return Locales.EN
}

const useLocaleStore = useLocalStorage<Locales>('previo_locale', defaultLocale)

export { Locales, useLocaleStore }
